import React from 'react'

function Footer() {
  return (
    <div className='d-flex justify-content-center mt-5 mb-5'>
      <i class="fa-brands fa-youtube fs-1 ms-5"></i>
      <i class="fa-brands fa-instagram fs-1 ms-5"></i>
      <i class="fa-brands fa-twitter fs-1 ms-5"></i>

    </div>
  )
} 

export default Footer